import { CoreStatusExtended as Status } from 'types';
import { allPathwayHandler } from './helpers';
import { configStagesSerializer } from './serializers';

interface IOption {
  label: string;
  value: string;
  populate?: {
    theme?: any;
    options: IOption[];
  };
}

export const getAssignStagesDropdownOptions = (
  configStages: Array<Status>,
  isAllPathwayStudents: boolean,
  isPathwayProvider: boolean,
  processedByUni?: boolean,
): IOption[] => {
  if (!isAllPathwayStudents) {
    configStages = allPathwayHandler(configStages);
  }
  const ConfigStatusDropdownOptions: Array<IOption> = configStagesSerializer(
    configStages,
    isPathwayProvider,
    processedByUni,
  );
  return ConfigStatusDropdownOptions;
};
